/**
 * 게시판 목록의 pathname+search를 sessionStorage에 저장해,
 * 브라우저 뒤로가기·「목록 돌아가기」 시 마지막 페이지(?page, ?tab 등)를 복원한다.
 *
 * 각 게시판은 고유한 storageKey와 목록 pathname prefix(예: /support/glow-news/news)를 정의해
 * readBoardListLastPath / writeBoardListLastPath / resolveBoardListBackHref 를 사용한다.
 * prefix는 정확히 일치하거나 `?`로만 이어지는 경우만 유효해, /register·/:id 같은 하위 경로는 저장·복원 대상에서 제외된다.
 */

/** URL 쿼리: 목록 페이지 (1-based). 알림&지원·기술 수요 등 공통 */
export const BOARD_LIST_PAGE_QUERY_KEY = 'page';

/** URL 쿼리: 목록 상단 탭 인덱스 등 (선택) */
export const BOARD_LIST_TAB_QUERY_KEY = 'tab';

/**
 * @param {string} listPathPrefix 목록 라우트 pathname (끝 슬래시 없음)
 * @param {string} stored pathname+search
 */
export function isBoardListStoredPathValid(listPathPrefix, stored) {
  if (!stored || typeof stored !== 'string' || !listPathPrefix) return false;
  if (stored === listPathPrefix) return true;
  return stored.startsWith(`${listPathPrefix}?`);
}

export function readBoardListLastPath(storageKey) {
  try {
    const v = sessionStorage.getItem(storageKey);
    return typeof v === 'string' ? v : '';
  } catch {
    return '';
  }
}

/**
 * @param {string} storageKey sessionStorage 키
 * @param {string} listPathPrefix 목록 pathname
 * @param {string} pathnameAndSearch `${pathname}${search}`
 */
export function writeBoardListLastPath(storageKey, listPathPrefix, pathnameAndSearch) {
  try {
    if (!isBoardListStoredPathValid(listPathPrefix, pathnameAndSearch)) return;
    sessionStorage.setItem(storageKey, pathnameAndSearch);
  } catch {
    /* ignore */
  }
}

/**
 * 저장된 목록 URL이 유효하면 반환, 아니면 fallbackHref
 * @param {string} storageKey
 * @param {string} listPathPrefix
 * @param {string} fallbackHref
 * @returns {string}
 */
export function resolveBoardListBackHref(storageKey, listPathPrefix, fallbackHref) {
  const stored = readBoardListLastPath(storageKey);
  if (isBoardListStoredPathValid(listPathPrefix, stored)) return stored;
  return fallbackHref;
}
